import { MACRO_KEY } from "../../../defaults";

export const options = {
  width: {
    default: "400px",
    [MACRO_KEY.CARDS]: "550px",
  },
};
